import React from "react";
import { connect } from "react-redux";
import { IProduct } from "../../redux/modules/products";
import { createErrorNotification } from "../../redux/modules/notifications";
import { withRouter } from "../../hooks/withRouter";
import { RootState } from "../../redux";

interface ProductFormProps {
  product?: IProduct;
  saveHandler?: (product: IProduct) => void;
  createErrorNotification?: (message: string) => void;
  readOnly?: boolean;
}

interface ProductFormState extends Partial<IProduct> {}

class ProductForm extends React.Component<ProductFormProps, ProductFormState> {
  constructor(props: ProductFormProps) {
    super(props);
    const { id, name, notes, basePrice, sellPrice, amount, unitType } = this.props.product || {
      id: 0,
      name: "",
      notes: "",
      basePrice: 0,
      sellPrice: 0,
      amount: 0,
      unitType: "piece"
    };
    this.state = {
      id,
      name,
      notes,
      basePrice,
      sellPrice,
      amount,
      unitType
    };
  }

  handleChange = (
    event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement> | React.ChangeEvent<HTMLTextAreaElement>,
    key: keyof IProduct
  ) => {
    const stateObj: ProductFormState = {};
    stateObj[key] = event.target.value as unknown as undefined;
    this.setState(stateObj);
  };

  save = () => {
    if (!this.state.name || !this.state.basePrice || !this.state.sellPrice || !this.state.basePrice || !this.state.unitType) {
      this.props.createErrorNotification && this.props.createErrorNotification("Заповніть обов'язкові поля");
      return;
    }
    const newState = { ...this.state };
    this.props.saveHandler && this.props.saveHandler(newState as IProduct);
  };

  componentDidUpdate(prevProps: Readonly<ProductFormProps>, prevState: Readonly<ProductFormState>, snapshot?: any): void {
    if (this.props.product?.amount !== prevProps.product?.amount) {
      this.setState({ amount: this.props.product?.amount });
    }
  }

  render() {
    const { name, notes, basePrice, sellPrice, amount, unitType } = this.state;
    const { readOnly } = this.props;
    return (
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="form-group">
          <label htmlFor="productFormName">
            Назва Товару <span style={{ color: "#ef4444" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            onChange={(event) => this.handleChange(event, "name")}
            id="productFormName"
            value={name || ""}
            required
            readOnly={readOnly}
          />
        </div>
        <div className="form-group">
          <label htmlFor="productFormUnitType">
            Одиниця обліку товару <span style={{ color: "#ef4444" }}>*</span>
          </label>
          <select className="form-select" onChange={(event) => this.handleChange(event, "unitType")} defaultValue={unitType} id="productFormUnitType" disabled={readOnly}>
            <option value="piece">Штука</option>
            <option value="ml">Мілілітр</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="productFormBasePrice">
            Закупівельна ціна за одиницю товару (грн) <span style={{ color: "#ef4444" }}>*</span>
          </label>
          <input
            type="number"
            className="form-control"
            onChange={(event) => this.handleChange(event, "basePrice")}
            id="productFormBasePrice"
            value={basePrice || ""}
            required
            min="0"
            step="0.01"
            readOnly={readOnly}
          />
        </div>
        <div className="form-group">
          <label htmlFor="productFormSellPrice">
            Ціна на продаж за одиницю товару (грн) <span style={{ color: "#ef4444" }}>*</span>
          </label>
          <input
            type="number"
            className="form-control"
            onChange={(event) => this.handleChange(event, "sellPrice")}
            id="productFormSellPrice"
            value={sellPrice || ""}
            required
            min="0"
            step="0.01"
            readOnly={readOnly}
          />
        </div>
        <div className="form-group">
          <label htmlFor="productFormAmount">Кількість</label>
          <input
            type="number"
            className="form-control-plaintext"
            onChange={(event) => this.handleChange(event, "amount")}
            id="productFormAmount"
            value={amount || ""}
            required
            readOnly
          />
        </div>
        <div className="form-group">
          <label htmlFor="productFormNotes">Нотатки</label>
          <textarea className="form-control" onChange={(event) => this.handleChange(event, "notes")} value={notes || ""} id="productFormNotes" readOnly={readOnly} />
        </div>
        {!readOnly && (
          <>
            <hr></hr>
            <button className="btn btn-primary" onClick={this.save}>
              Зберегти
            </button>
          </>
        )}
      </form>
    );
  }
}

const mapStateToProps = (state: RootState) => {
  return { products: Object.values(state.productsState.products) };
};

export default withRouter(connect(mapStateToProps, { createErrorNotification })(ProductForm));
